import {Component, OnInit} from '@angular/core';
import {AlertComponent} from "../../../shared/components/alert/alert.component";
import {LoadingComponent} from "../../../shared/components/loading/loading.component";
import {PaginationComponent} from "../../../shared/components/pagination/pagination.component";
import {TranslateModule} from "@ngx-translate/core";
import {CommonModule} from '@angular/common';
import {
  createPaginationState,
  setPaginationLoading,
  updatePaginationFromResult,
} from '../../../core/helpers/pagination-state.helper';
import {UserService} from '../../../core/services/user/user.service';
import {UserListModel} from '../../../core/models/user/query-user.model';
import {Router, RouterLink} from '@angular/router';
import {ButtonComponent} from '../../../shared/components/button/button.component';
import {FeatherPipe} from '../../../core/pipes/feather.pipe';

@Component({
  selector: 'app-list',
  imports: [
    AlertComponent,
    LoadingComponent,
    PaginationComponent,
    TranslateModule,
    CommonModule,
    RouterLink,
    ButtonComponent,
    FeatherPipe
  ],
  templateUrl: './user-list.component.html',
  styleUrl: './user-list.component.scss'
})
export class UserListComponent implements OnInit {

  error: string | null = null;

  users: UserListModel[] = [];
  readonly paginationState = createPaginationState();

  constructor(
    private readonly userService: UserService,
    private readonly router: Router
  ) {
  }

  ngOnInit(): void {
    this.onPageChange(0, 10);
  }

  createNewUser(): void {
    this.router.navigate(['/users/create']);
  }

  onPageChange = (page: number, pageSize: number): void => {
    setPaginationLoading(this.paginationState, true);
    this.error = null;

    this.userService.getUserByFilter({ page, pageSize }).subscribe({
      next: (result) => {
        this.users = result.content;
        updatePaginationFromResult(this.paginationState, result, pageSize);
      },
      error: (err) => {
        this.error = 'Falha ao carregar os lotes.';
        setPaginationLoading(this.paginationState, false);
        console.error(err);
      }
    });
  }
}
